interface RedCrossIconProps {
  height?: string;
  width?: string;
}

export function RedCrossIcon(props: RedCrossIconProps) {
  return (
    <>
      <svg
        width={props.width || "14"}
        height={props.height || "14"}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8 7C13.8 10.866 10.7555 14 7.00001 14C3.24448 14 0.200012 10.866 0.200012 7C0.200012 3.13401 3.24448 0 7.00001 0C10.7555 0 13.8 3.13401 13.8 7ZM4.98089 4.01917C4.71534 3.75361 4.28478 3.75361 4.01923 4.01917C3.75367 4.28472 3.75367 4.71528 4.01923 4.98083L6.0384 7L4.01923 9.01917C3.75367 9.28472 3.75367 9.71528 4.01923 9.98083C4.28478 10.2464 4.71534 10.2464 4.98089 9.98083L7.00006 7.96167L9.01923 9.98083C9.28478 10.2464 9.71534 10.2464 9.98089 9.98083C10.2465 9.71528 10.2465 9.28472 9.98089 9.01917L7.96173 7L9.98089 4.98083C10.2465 4.71528 10.2465 4.28472 9.98089 4.01917C9.71534 3.75361 9.28478 3.75361 9.01923 4.01917L7.00006 6.03833L4.98089 4.01917Z"
          fill="#BB0202"
        />
      </svg>
    </>
  );
}
